var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "supplier-manage bj" },
    [
      _c("div", { staticClass: "title" }, [
        _c(
          "div",
          { staticClass: "form jn-form-style" },
          [
            _c(
              "div",
              { staticClass: "form-item btn-wrap" },
              [
                _c("el-button", {
                  staticClass: "refresh",
                  staticStyle: { "margin-left": "5px" },
                  attrs: { type: "primary", icon: "el-icon-refresh" },
                  on: { click: _vm.onHandleRefresh },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "form-item" },
              [
                _c(
                  "el-select",
                  {
                    attrs: { placeholder: "选择集配中心", clearable: "" },
                    model: {
                      value: _vm.formData.logistic_business_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "logistic_business_id", $$v)
                      },
                      expression: "formData.logistic_business_id",
                    },
                  },
                  _vm._l(_vm.logisticsList, function (item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: { label: item.name, value: item.id },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "form-item" },
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入业务员名称", clearable: "" },
                  model: {
                    value: _vm.formData.buyer_name,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "buyer_name", $$v)
                    },
                    expression: "formData.buyer_name",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "form-item" },
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入所属小组", clearable: "" },
                  model: {
                    value: _vm.formData.team_name,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "team_name", $$v)
                    },
                    expression: "formData.team_name",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "form-item" },
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入采购电话", clearable: "" },
                  model: {
                    value: _vm.formData.buyer_mobile,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "buyer_mobile", $$v)
                    },
                    expression: "formData.buyer_mobile",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "form-item" },
              [
                _c(
                  "el-select",
                  {
                    attrs: { clearable: "", placeholder: "请选择状态" },
                    model: {
                      value: _vm.formData.buyer_state,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "buyer_state", $$v)
                      },
                      expression: "formData.buyer_state",
                    },
                  },
                  [
                    _c("el-option", {
                      attrs: { label: "全部状态", value: "" },
                    }),
                    _c("el-option", { attrs: { label: "启用", value: "1" } }),
                    _c("el-option", { attrs: { label: "禁用", value: "2" } }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "form-item" },
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入供应商名称", clearable: "" },
                  model: {
                    value: _vm.formData.supplier_name,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "supplier_name", $$v)
                    },
                    expression: "formData.supplier_name",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "form-item" },
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入供应商电话", clearable: "" },
                  model: {
                    value: _vm.formData.supplier_mobile,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "supplier_mobile", $$v)
                    },
                    expression: "formData.supplier_mobile",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-button",
              {
                attrs: { type: "primary", icon: "el-icon-search" },
                on: { click: _vm.onHandleSearch },
              },
              [_vm._v("查询")]
            ),
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.onHandleExport } },
              [_vm._v("导 出")]
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "auto-table-flex" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: {
                data: _vm.tableData,
                height: "100%",
                border: true,
                "header-cell-style": {
                  color: "#333333",
                  background: "#EFF6FF",
                },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  width: "80px",
                  align: "center",
                  label: "序号",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "buyer_name", align: "center", label: "业务员" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$empty.empty(scope.row.buyer.fullname)) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "supplier_name",
                  align: "center",
                  label: "发品供应商",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$empty.empty(scope.row.supplier.title)) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "onsale_num",
                  align: "center",
                  label: "在售商品数量",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "outsale_num",
                  align: "center",
                  label: "下架商品数量",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "sit_text",
                  align: "center",
                  label: "是否限制坑位",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "sit_num", align: "center", label: "坑位数" },
              }),
              _c("el-table-column", {
                attrs: { prop: "stock_add", align: "center", label: "加库存" },
              }),
              _c("el-table-column", {
                attrs: { prop: "stock_sub", align: "center", label: "减库存" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "stock_sub",
                  align: "center",
                  label: "下架商品",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "create_sku",
                  align: "center",
                  label: "新建商品",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "edit_sku", align: "center", label: "编辑商品" },
              }),
              _c("el-table-column", {
                attrs: { prop: "change_pic", align: "center", label: "换图" },
              }),
              _c("el-table-column", {
                attrs: { label: "操作", align: "center", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.onHandleEdit(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "fy" },
        [
          _c("el-pagination", {
            attrs: {
              type: "primary",
              background: "",
              "current-page": _vm.currentPage,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.formData.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm.editDialogVisible
        ? _c(
            "el-dialog",
            {
              staticClass: "dialog supplier-dialog",
              attrs: {
                title: _vm.dialogTitle,
                visible: _vm.editDialogVisible,
                width: "50%",
                center: "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.editDialogVisible = $event
                },
              },
            },
            [
              _c("div", { staticClass: "contents" }, [
                _c("div", { staticClass: "info-section" }, [
                  _c("div", { staticClass: "info-title" }, [
                    _vm._v("基础信息"),
                  ]),
                  _c("div", { staticClass: "info-grid" }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "info-label" }, [
                        _vm._v("供应商："),
                      ]),
                      _c("span", { staticClass: "info-value" }, [
                        _vm._v(
                          _vm._s(_vm.editForm.supplier_name) +
                            "【" +
                            _vm._s(_vm.editForm.supplier_mobile) +
                            "】"
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "info-label" }, [
                        _vm._v("采购："),
                      ]),
                      _c("span", { staticClass: "info-value" }, [
                        _vm._v(
                          _vm._s(_vm.editForm.buyer_name) +
                            "【" +
                            _vm._s(_vm.editForm.buyer_mobile) +
                            "】"
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "info-label" }, [
                        _vm._v("在售商品："),
                      ]),
                      _c("span", { staticClass: "info-value" }, [
                        _vm._v(_vm._s(_vm.editForm.on_sale_count)),
                      ]),
                    ]),
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "info-label" }, [
                        _vm._v("下架商品："),
                      ]),
                      _c("span", { staticClass: "info-value" }, [
                        _vm._v(_vm._s(_vm.editForm.off_sale_count)),
                      ]),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "auth-section" }, [
                  _c(
                    "div",
                    { staticClass: "auth-list" },
                    _vm._l(_vm.authConfigList, function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "auth-item" },
                        [
                          _c(
                            "div",
                            { staticClass: "auth-row" },
                            [
                              _c("span", { staticClass: "auth-name-label" }, [
                                _vm._v(_vm._s(item.name) + "："),
                              ]),
                              _c(
                                "el-radio-group",
                                {
                                  attrs: { size: "small" },
                                  model: {
                                    value: item.value,
                                    callback: function ($$v) {
                                      _vm.$set(item, "value", $$v)
                                    },
                                    expression: "item.value",
                                  },
                                },
                                _vm._l(item.options, function (opt) {
                                  return _c(
                                    "el-radio",
                                    {
                                      key: opt.value,
                                      attrs: { label: opt.value },
                                      nativeOn: {
                                        input: function ($event) {
                                          return ((data) => {
                                            _vm.changeInput(data, item)
                                          }).apply(null, arguments)
                                        },
                                      },
                                    },
                                    [_vm._v(" " + _vm._s(opt.label) + " ")]
                                  )
                                }),
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "auth-options" },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: { size: "small" },
                                      model: {
                                        value: item.allowChange,
                                        callback: function ($$v) {
                                          _vm.$set(item, "allowChange", $$v)
                                        },
                                        expression: "item.allowChange",
                                      },
                                    },
                                    [_vm._v(" 允许采购更改 ")]
                                  ),
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: { size: "small" },
                                      model: {
                                        value: item.applyAll,
                                        callback: function ($$v) {
                                          _vm.$set(item, "applyAll", $$v)
                                        },
                                        expression: "item.applyAll",
                                      },
                                    },
                                    [_vm._v(" 应用于该采购全部供应商 ")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          item.auth_type === "1"
                            ? _c(
                                "div",
                                { staticClass: "slot-row" },
                                [
                                  _c("span", { staticClass: "slot-label" }, [
                                    _vm._v("坑位数："),
                                  ]),
                                  _c("el-input", {
                                    staticClass: "slot-input",
                                    attrs: {
                                      disabled: item.value === 0,
                                      placeholder: "请输入坑位数",
                                    },
                                    model: {
                                      value: _vm.editForm.slot_count,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.editForm,
                                          "slot_count",
                                          $$v
                                        )
                                      },
                                      expression: "editForm.slot_count",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
              ]),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.editDialogVisible = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.onHandleSubmit },
                    },
                    [_vm._v("确 定")]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }